module.exports = __webpack_public_path__ + "static/media/income-statement.c994c954.svg";